<template>
  <div class="info-card">
    <h1 v-if="title" class="info-card__title">{{ title }}</h1>
    <div class="info-card__content">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.info-card {
  border-radius: 4px;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
  background: var(--card-color, #fff);
  padding: 16px 20px 20px 20px;
  margin: 10px;
  min-width: 0;
  height: fit-content;
}

.info-card__title {
  font-size: 1.12rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--color-primary-500, #1976d2);
}

.info-card__content {
  display: flex;
  flex-direction: column;
}
</style>
